<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/call-driver" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Trip Checkout</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goNewTrip()" aria-label="New trip">
        <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ride-list" *ngIf="savedRides.length > 0; else emptyState">
    <ion-card *ngFor="let ride of savedRides" class="ride-card">
      <ion-card-header>
        <div class="card-header-flex">
          <div class="header-text">
            <ion-card-title>{{ ride.nomePassageiro }}</ion-card-title>
            <ion-card-subtitle>{{ ride.celularCliente }}</ion-card-subtitle>
          </div>
          <ion-checkbox
            slot="end"
            *ngIf="isSalva(ride)"
            [checked]="isSelected(ride.id)"
            (ionChange)="toggleSelect(ride.id)"
          ></ion-checkbox>
          <ion-badge
            slot="end"
            *ngIf="!isSalva(ride)"
            [color]="ride.statusPagamentoLink === StatusPagamentoLink.PENDENTE ? 'warning' : 'success'"
          >
            {{ ride.statusPagamentoLink === StatusPagamentoLink.PENDENTE ? 'Pending' : 'Paid' }}
          </ion-badge>
        </div>
      </ion-card-header>
      
      <ion-card-content>
        <div class="ride-detail-row">
          <ion-icon name="location-outline" color="primary"></ion-icon>
          <p><strong>From:</strong> {{ ride.enderecoOrigem }}</p>
        </div>
        <div class="ride-detail-row">
          <ion-icon name="flag-outline" color="secondary"></ion-icon>
          <p><strong>To:</strong> {{ ride.enderecoDestino }}</p>
        </div>
        <div class="ride-detail-row">
          <ion-icon name="calendar-outline" color="medium"></ion-icon>
          <p><strong>Date:</strong> {{ ride.dataAgendamentoCorrida | date:'MMM d, y, h:mm a' }}</p>
        </div>
        <div class="ride-detail-row price-row">
          <ion-icon name="cash-outline" color="success"></ion-icon>
          <p class="price-text"><strong>Price:</strong> ${{ ride.valorCorrida | number:'1.2-2' }}</p>
        </div>
      </ion-card-content>
      
      <div class="card-footer" *ngIf="isPendente(ride)">
        <ion-button fill="clear" size="small" color="primary" (click)="shareExistingLink(ride)">
          <ion-icon name="share-social-outline" slot="start"></ion-icon> Share
        </ion-button>
        <ion-button fill="clear" size="small" color="medium" (click)="copyExistingLink(ride)">
          <ion-icon name="copy-outline" slot="start"></ion-icon> Copy
        </ion-button>
        <ion-button fill="clear" size="small" color="danger" (click)="deleteRide(ride, $event)">
          <ion-icon name="trash-outline" slot="start"></ion-icon> Delete
        </ion-button>
      </div>
      <div class="card-footer" *ngIf="isSalva(ride)">
        <ion-button fill="clear" size="small" color="danger" (click)="deleteRide(ride, $event)">
          <ion-icon name="trash-outline" slot="start"></ion-icon> Delete
        </ion-button>
      </div>
    </ion-card>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <div class="empty-icon-container">
        <ion-icon name="cart-outline"></ion-icon>
      </div>
      <h3>Your cart is empty</h3>
      <p>Save trips to checkout and share payment links with your customers.</p>
      <ion-button (click)="goNewTrip()" mode="ios">Book a Ride</ion-button>
    </div>
  </ng-template>
</ion-content>

<ion-footer *ngIf="selectedIds.size > 0" class="ion-no-border">
  <div class="fee-disclosure">
    A {{ feePercent | number:'1.1-2' }}% transaction fee has been included in this transaction.
  </div>
  <ion-toolbar>
    <div class="footer-content">
      <div class="total-section">
        <div class="totals-breakdown">
          <span class="line"><span>Subtotal</span><span>${{ subtotal | number:'1.2-2' }}</span></span>
          <span class="line"><span>Fee ({{ feePercent | number:'1.1-2' }}%)</span><span>${{ feeAmount | number:'1.2-2' }}</span></span>
        </div>
        <span class="total-label">Total Amount</span>
        <h2 class="total-value">${{ totalSelected | number:'1.2-2' }}</h2>
      </div>
      <ion-buttons slot="end">
        <ion-button color="primary" fill="solid" (click)="sendPaymentLink()">
          Checkout <ion-icon name="arrow-forward" slot="end"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </ion-toolbar>
</ion-footer>
